import React, { useEffect, useState } from 'react';

// Third Party Libraries
import { CategoryScale } from 'chart.js';
import Chart from 'chart.js/auto';

// Utils
import { MESSAGES } from '~/utils/message';

// Components
import PieChart from './pieChart';
import ChoroplethUsStates from './choroplethUsStates';

// Icons
import { AnalyticsNoDataCIcon, ContactInfoCIcon } from '~/assets/images';

// MUI Components
import { Box, Typography, Skeleton, Tooltip } from '@mui/material';

// Style
import './styles.scss';

Chart.register(CategoryScale);
// styles

function Analytics({ info, stepper, loading = false }) {
  const [isData, setIsData] = useState(false);

  const gridContainerStyle = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '10px',
  };

  const gridItemStyle = {
    padding: '0px 40px 70px',
  };

  useEffect(() => {
    if (stepper.status == 'Mailed' || stepper.status == 'Completed') {
      setIsData(true);
    }
  }, [stepper.status]);

  // Skeleton loading component
  const renderSkeleton = () => (
    <Box className="analytics_wrapper">
      {/* <p className="title">Analytics</p> */}
      <Box sx={{display: 'flex', justifyContent: 'flex-start'}}>
        <Box className="title" sx={{flex: "1.2"}}>
          Tracking 
          <Tooltip title={MESSAGES.ORDERS.DETAIL.OVERVIEW.TRACKING_INFO} placement='bottom-start'
          componentsProps={{
            tooltip: {
              sx: {
                fontSize: '12px',
                maxWidth: '231px',
                padding: '8px !important',
              }
            }
          }}>
            <img src={ContactInfoCIcon} alt="info" />
          </Tooltip>
        </Box>
        <Box className="title" sx={{flex: "1"}}>
        Scanning 
        <Tooltip title={MESSAGES.ORDERS.DETAIL.OVERVIEW.SCANNING_INFO} placement='bottom-start'
          componentsProps={{
            tooltip: {
              sx: {
                fontSize: '12px',
                maxWidth: '235px',
                padding: '8px !important',
              }
            }
          }}>
            <img src={ContactInfoCIcon} alt="info" />
        </Tooltip>
        </Box>
      </Box>
      <div style={gridContainerStyle}>
        <div style={{ ...gridItemStyle }}>
          <Skeleton 
            variant="circular" 
            width={426} 
            height={426} 
            sx={{ margin: '0 auto' }}
          />
        </div>
        <div style={gridItemStyle}>
          <Skeleton 
            variant="rectangular" 
            width="100%" 
            height={426} 
            sx={{ borderRadius: '8px' }}
          />
        </div>
      </div>
    </Box>
  );

  // Show skeleton while loading
  if (loading) {
    return renderSkeleton();
  }

  return (
    <Box className="analytics_wrapper">
      {/* <p className="title">Analytics</p> */}
      <Box sx={{display: 'flex', justifyContent: 'flex-start'}}>
        <Box className="title" sx={{flex: "1.2"}}>
          Tracking 
          <Tooltip title={MESSAGES.ORDERS.DETAIL.OVERVIEW.TRACKING_INFO} placement='bottom-start'
          componentsProps={{
            tooltip: {
              sx: {
                fontSize: '12px',
                maxWidth: '231px',
                padding: '8px !important',
              }
            }
          }}>
            <img src={ContactInfoCIcon} alt="info" />
          </Tooltip>
        </Box>
        <Box className="title" sx={{flex: "1"}}>
        Scanning 
        <Tooltip title={MESSAGES.ORDERS.DETAIL.OVERVIEW.SCANNING_INFO} placement='bottom-start'
          componentsProps={{
            tooltip: {
              sx: {
                fontSize: '12px',
                maxWidth: '235px',
                padding: '8px !important',
              }
            }
          }}>
            <img src={ContactInfoCIcon} alt="info" />
        </Tooltip>
        </Box>
      </Box>
      <div style={gridContainerStyle} className="analytics_grid_container">
        {isData && (
          <>
            <div style={{ ...gridItemStyle }} className="analytics_grid_item">
              {' '}
              <PieChart info={info} deliverableQuantity={stepper?.deliverableQuantity || 0} />{' '}
            </div>
          </>
        )}
        {isData && (
          <>
            <div style={gridItemStyle}>
              {' '}
              <ChoroplethUsStates info={info} />{' '}
            </div>
          </>
        )}
      </div>

      {!isData && (
        <Box className="analytics_imp_parent">
          <Box className="analytics_imp_parent_content">
          <Typography className="analytics_text_heading">
            {MESSAGES.ORDERS.DETAIL.OVERVIEW.NO_DATA}
          </Typography>
          <Typography className="analytics_text">
            {MESSAGES.ORDERS.DETAIL.OVERVIEW.NO_DATA_ANALYTICS}
          </Typography>
          </Box>
          <img src={AnalyticsNoDataCIcon} className="analytic_img" alt="img" />
        </Box>
      )}
    </Box>
  );
}

export default Analytics;
